import timeNone from './time-none';
import countriesNone from './countries';

export default [...timeNone, ...countriesNone];